import { getConfig } from "../../lib/configMgr";

/**
 * releaseNotesEnabled — gates the v2 "What's New" overlay + v2 account menu.
 *
 * ON wherever the v2 workspace is on: the cell's `withV2` build flag (WITH_V2 in the
 * Makefile: dev and beta today; a prod cell only with an explicit, change-controlled
 * opt-in), not the cell's name (PLEX-6675). `localStorage` key
 * `workspace.releaseNotes` is an instant kill switch / opt-in ('1' on, '0' off);
 * `REACT_APP_RELEASE_NOTES=true` forces it for any build.
 *
 * Mirrors the chatStoreEnabled() pattern in ConversationStreamProvider.
 */
export const releaseNotesEnabled = () => {
  try {
    const ls = (typeof window !== "undefined" && window.localStorage)
      ? window.localStorage.getItem("workspace.releaseNotes") : null;
    if (ls === "1") return true;
    if (ls === "0") return false;
  } catch (_) { /* ignore */ }
  if (process.env.REACT_APP_RELEASE_NOTES === "true") return true;
  try { return !!getConfig().withV2; } catch (_) { return false; }
};

export default releaseNotesEnabled;
